import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
// import { TYPE } from '../../../theme'
import { Text } from 'rebass'
import { useHistory } from 'react-router-dom';

// hooks
import { useActiveWeb3React } from '../../../hooks'

// components
import LaunchErr from './LaunchErr'
import { ButtonEmpty } from '../../../components/Button'
import Row from '../../../components/Row'

const LaunchPut = styled.input<{ width?: string, disabled?: boolean }>`
  margin-top: 10px;
  padding: 0 24px;
  width: ${({ width }) => (width ? width : '100%')};
  height: 56px;
  line-height: 20px;
  background: ${({ theme }) => theme.bsBg32};
  box-sizing: border-box;
  border-radius: 10px;
  color: ${({ disabled, theme }) => disabled ? '#E1B697' : theme.bsText36};
  font-family: 'Roboto-Medium';
  font-size: 16px;
  outline: none;
  contenteditable: true;
  border: 1px solid ${({ theme }) => theme.bsBg32};
  -webkit-appearance: none;

  ::placeholder {
    color: ${({ theme }) => theme.bsText27};
  }
  :hover {
    border: 1px solid ${({ theme }) => theme.bsBorder7};
    box-shadow: 0px 2px 12px ${({theme}) => theme.darkMode ? 'none' : 'rgba(255, 221, 171, 0.6)'};
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `}
  &[type=number] {
    -moz-appearance:textfield;
  }

  &[type=number]::-webkit-inner-spin-button,
  &[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`
const LaunchTextarea = styled.textarea`
  margin-top: 10px;
  padding: 17px 24px;
  width: 100%;
  height: 137px;
  line-height: 20px;
  background: ${({ theme }) => theme.bsBg32};
  border: 1px solid ${({ theme }) => theme.bsBg32};
  box-sizing: border-box;
  border-radius: 10px;
  color: ${({ theme }) => theme.bsText36};
  font-family: 'Roboto-Medium';
  font-size: 16px;
  outline: none;
  resize: none;
  -webkit-appearance: none;
  
  ::placeholder {
    color: ${({ theme }) => theme.bsText27};
  }
  :hover {
    border: 1px solid ${({ theme }) => theme.bsBorder7};
    box-shadow: 0px 2px 12px ${({theme}) => theme.darkMode ? 'none' : 'rgba(255, 221, 171, 0.6)'};
  }
`
const ButtonEdit = styled(ButtonEmpty)`
  font-size: 14px;
  border: 1px solid ${({theme}) => theme.bsText2};
  border-radius: 5px;
`

const AutoInput = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
  padding: 21px 24px;
  width: 100%;
  height: 56px;
  line-height: 20px;
  background: ${({ theme }) => theme.bsBg32};
  border: 1px solid ${({ theme }) => theme.bsBg32};
  box-sizing: border-box;
  border-radius: 10px;
  :hover {
    border: 1px solid ${({ theme }) => theme.bsBorder7};
    box-shadow: 0px 2px 12px ${({theme}) => theme.darkMode ? 'none' : 'rgba(255, 221, 171, 0.6)'};
  }
  .title {
    font-family: 'Roboto-Medium';
    flex-shrink: 0;
    font-size: 14px;
    line-height: 16px;
    color: #322925;
  }
  input {
    margin-left: 8px;
    flex-shrink: 1;
    width: 100%;
    height: 56px;
    outline: none;
    border: none;
    background: none;
    font-size: 14px;
    font-family: 'Roboto-Medium';
    color: ${({ theme }) => theme.bsText36};
    ::placeholder {
      color: ${({ theme }) => theme.bsText27};
    }
    &[type=number] {
      -moz-appearance:textfield;
    }

    &[type=number]::-webkit-inner-spin-button,
    &[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  img {
    width: 20px;
    height: 20px;
  }
`


export function LaunchText(
  {
    info, title, margin
  }: 
  {
    info?: any, title?: string, margin?: string
  }) {
    const theme = useContext(ThemeContext)
    const { account } = useActiveWeb3React()
    const history = useHistory()

    const jump = () => {
      history.push(`/personalInfo/${account}`)
    }

    return (
      <>
        {
          title ? <Row>
            <Text fontSize={16} color={theme.bsText37} fontFamily="Roboto-Bold" margin={margin}>
              {title}
              {
                info?.star ? <span style={{color: theme.bsText18}}> *</span> : ''
              }
            </Text>
            {
              title === 'Artist Name' && <ButtonEdit onClick={jump} padding="0" width={'30px'} minWidth={'30px'} height={30} marginLeft="10px"><img src="/images/artworks/icon_edit.svg" alt=""/></ButtonEdit>
            }
          </Row> : ''
      }
      </>
    )
  }

// export interface Info {
//   text: string
//   err: string
//   errShow: boolean
//   placeholder: string

// }

export default function LaunchInput(
  {
    info, title, type, 
    inputType, nameHave, 
    inputChange, inputBlur,
    inputType2
  }: 
  {
    info: any, title?: string, 
    type: string, inputType?: string, 
    nameHave?: boolean, inputChange: any, 
    inputBlur: any, inputType2?: string
  }) {
  // const theme = useContext(ThemeContext)
  // const { account } = useActiveWeb3React()
  // const history = useHistory()

  // const jump = () => {
  //   history.push(`/personalInfo/${account}`)
  // }

  return (
    <>
      <LaunchText info={info} title={title}></LaunchText>
      {
        inputType ? (
          <LaunchTextarea
            value={info.text}
            placeholder={info.placeholder}
            onChange={event => {
              inputChange(type, event)
            }}
            onBlur={() => {
              inputBlur(type)
            }}
          ></LaunchTextarea>
        ) : (
          !info.leftText && !info.leftIcon
          ? <LaunchPut
              type={inputType2 ? inputType2 : 'text'}
              disabled={nameHave}
              value={info.text}
              placeholder={info.placeholder}
              onChange={event => {
                inputChange(type, event)
              }}
              onBlur={() => {
                inputBlur(type)
              }}
            ></LaunchPut>
          : <AutoInput>
              {
                info.leftText ? <div className="title">{info.leftText}</div> : <img src={info.leftIcon} alt="" />
              }
              <input
                type={inputType2 ? inputType2 : 'text'}
                disabled={nameHave}
                value={info.text}
                placeholder={info.placeholder}
                onChange={event => {
                  inputChange(type, event)
                }}
                onBlur={() => {
                  inputBlur(type)
                }}
              ></input>
            </AutoInput>
        )
      }
      <LaunchErr errShow={info.errShow} text={info.err}></LaunchErr>
    </>
  )
}
